(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js') >= 0) return;  svs.modules.push('/modules/lyckoplatsen/components/page-play/assets/react/play-page.js');

'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const _React = React,
  useEffect = _React.useEffect,
  useState = _React.useState,
  useRef = _React.useRef;
const _svs$lyckoplatsen$com = svs.lyckoplatsen.components.page_play.react.components,
  Betslip = _svs$lyckoplatsen$com.Betslip,
  MapPlay = _svs$lyckoplatsen$com.MapPlay,
  Search = _svs$lyckoplatsen$com.Search,
  HomeButton = _svs$lyckoplatsen$com.HomeButton,
  RightBottomButtons = _svs$lyckoplatsen$com.RightBottomButtons,
  PlayPageContainer = _svs$lyckoplatsen$com.PlayPageContainer,
  Params = _svs$lyckoplatsen$com.Params,
  SearchOverlay = _svs$lyckoplatsen$com.SearchOverlay,
  Charity = _svs$lyckoplatsen$com.Charity,
  Campaign = _svs$lyckoplatsen$com.Campaign;
const useStorageWager = svs.lyckoplatsen.page_play.utils.useStorageWager;
const mapErrorDialog = svs.lyckoplatsen.shared_map.utils.mapErrorDialog;
const jwt = svs.lyckoplatsen.data.config.jwt;
const useResetPlayAtoms = svs.lyckoplatsen.components.page_play.react.hooks.useResetPlayAtoms;
const _jotai = jotai,
  useAtomValue = _jotai.useAtomValue,
  useSetAtom = _jotai.useSetAtom;
const _svs$lyckoplatsen$com2 = svs.lyckoplatsen.components.page_play.jotai.atoms,
  newCustomerCampaignAtom = _svs$lyckoplatsen$com2.newCustomerCampaignAtom,
  newCustomerCampaignPlayAtom = _svs$lyckoplatsen$com2.newCustomerCampaignPlayAtom,
  mapLocationAtom = _svs$lyckoplatsen$com2.mapLocationAtom,
  pinLocationAtom = _svs$lyckoplatsen$com2.pinLocationAtom;
const CONSTANTS = svs.lyckoplatsen.components.shared_constants.CONSTANTS;
const PlayPage = () => {
  useStorageWager();
  const resetPlayAtoms = useResetPlayAtoms();
  const resetPlayAtomsRef = useRef(resetPlayAtoms);
  resetPlayAtomsRef.current = resetPlayAtoms;
  const campaign = useAtomValue(newCustomerCampaignAtom);
  const campaignPlay = useAtomValue(newCustomerCampaignPlayAtom);
  const setMapLocation = useSetAtom(mapLocationAtom);
  const pinLocation = useAtomValue(pinLocationAtom);
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isLoaded = _useState2[0],
    setIsLoaded = _useState2[1];
  const _useState3 = useState(null),
    _useState4 = _slicedToArray(_useState3, 2),
    campaignCoords = _useState4[0],
    setCampaignCoords = _useState4[1];
  const _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    applyLoadedClass = _useState6[0],
    setApplyLoadedClass = _useState6[1];
  const _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    isExternal = _useState8[0],
    setIsExternal = _useState8[1];
  useEffect(() => {
    if (!isExternal && applyLoadedClass) {
      var _svs$utils$paramHandl;
      const paramCoords = (_svs$utils$paramHandl = svs.utils.paramHandler.get({
        key: 'coords'
      })) === null || _svs$utils$paramHandl === void 0 ? void 0 : _svs$utils$paramHandl.value;
      const _ref = (paramCoords === null || paramCoords === void 0 ? void 0 : paramCoords.split(',').map(Number)) || [],
        _ref2 = _slicedToArray(_ref, 2),
        latitude = _ref2[0],
        longitude = _ref2[1];
      if (campaign.isActive) {
        resetPlayAtomsRef.current();
      }
      if (latitude && longitude && campaign.isActive) {
        setCampaignCoords({
          lat: latitude,
          lng: longitude
        });
      } else if (latitude && longitude && !campaign.hasCampaignIdParam) {
        resetPlayAtomsRef.current();
        setIsExternal(Boolean(paramCoords));
        setMapLocation({
          lat: latitude,
          lng: longitude,
          zoomLevel: CONSTANTS.FIRST_ZOOM_LEVEL,
          resetView: true,
          delay: 2,
          onStart: mapHandler => {
            mapHandler.placeStartClickCircle({
              lat: latitude,
              lng: longitude
            });
          }
        });
        svs.utils.paramHandler.remove({
          key: 'coords'
        });
      }
    }
  }, [applyLoadedClass, campaign.hasCampaignIdParam, campaign.isActive, isExternal, setMapLocation]);
  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 300);
    if (typeof jwt !== 'string' || jwt.length === 0) {
      mapErrorDialog();
    }
    return () => clearTimeout(timer);
  }, []);
  useEffect(() => {
    if (isLoaded) {
      const timer = setTimeout(() => setApplyLoadedClass(true), 30);
      return () => clearTimeout(timer);
    }
  }, [isLoaded]);
  let pageLoadedClass = '';
  if (applyLoadedClass) {
    pageLoadedClass = campaign.isActive ? 'page-loaded-from-start campaign' : 'page-loaded';
  }
  if (!isLoaded) {
    return null;
  }
  return React.createElement(PlayPageContainer, null, React.createElement(Params, null), React.createElement("div", {
    className: "lp-map-play-container relative ".concat(pageLoadedClass, " ").concat(campaignPlay ? 'play-campaign' : '')
  }, React.createElement("div", {
    className: "lp-map-play-top"
  }, React.createElement("div", {
    className: "animated-body"
  }, React.createElement(Search, null), React.createElement(HomeButton, null))), campaign.isActive && applyLoadedClass && !pinLocation && React.createElement(Campaign, {
    coords: campaignCoords
  }), isLoaded && React.createElement(MapPlay, {
    nodeId: "map-play"
  }), React.createElement(RightBottomButtons, null), React.createElement(Charity, null), React.createElement(Betslip, null)), React.createElement(SearchOverlay, null));
};
setGlobal('svs.lyckoplatsen.components.page_play.react', {
  PlayPage
});

 })(window);